import React, { useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Collapse,
} from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import SecurityIcon from "@mui/icons-material/Security";
import DescriptionIcon from "@mui/icons-material/Description";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { useNavigate, useLocation } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [openExclusive, setOpenExclusive] = useState(true);
  const [openCPanel, setOpenCPanel] = useState(true);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <Box
  sx={{
    width: 260,
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    background: "linear-gradient(180deg, #020617, #0f172a)",
    color: "#e5e7eb",
    overflowY: "auto",
  }}
>


      {/* Logo */}
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography variant="h6" fontWeight="bold">
          Admin Panel
        </Typography>
      </Box>

      <Divider sx={{ bgcolor: "rgba(255,255,255,0.1)" }} />

      <List>
        {/* Dashboard */}
        <ListItemButton
         selected={isActive("/warals/dashboard")}
onClick={() => navigate("/warals/dashboard")}
        >
          <ListItemIcon sx={{ color: "white" }}>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>

        <Divider sx={{ bgcolor: "rgba(255,255,255,0.1)", my: 1 }} />

        {/* ================= EXCLUSIVE PERMISSION ================= */}
        <ListItemButton onClick={() => setOpenExclusive(!openExclusive)}>
          <ListItemIcon sx={{ color: "white" }}>
            <SecurityIcon />
          </ListItemIcon>
          <ListItemText primary="Exclusive Permission" />
          {openExclusive ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openExclusive} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
             selected={isActive("/warals/form-module")}
onClick={() => navigate("/warals/form-module")}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <DescriptionIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Module" />
            </ListItemButton>

            <ListItemButton
              sx={{ pl: 4 }}
              selected={isActive("/warals/form-register")}
onClick={() => navigate("/warals/form-register")}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <DescriptionIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Form" />
            </ListItemButton>
          </List>
        </Collapse>

        <Divider sx={{ bgcolor: "rgba(255,255,255,0.1)", my: 1 }} />

        {/* ================= C-PANEL ================= */}
        <ListItemButton onClick={() => setOpenCPanel(!openCPanel)}>
          <ListItemIcon sx={{ color: "white" }}>
            <ManageAccountsIcon />
          </ListItemIcon>
          <ListItemText primary="C-Panel" />
          {openCPanel ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openCPanel} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              selected={isActive("/warals/user-group")}
onClick={() => navigate("/warals/user-group")}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <GroupIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="User Group" />
            </ListItemButton>

            {/* <ListItemButton
              sx={{ pl: 4 }}
              selected={isActive("/warals/user")}
onClick={() => navigate("/warals/user")}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="User" />
            </ListItemButton> */}

            <ListItemButton
              sx={{ pl: 4 }}
              selected={isActive("/warals/manage-user")}
onClick={() => navigate("/warals/manage-user")}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <ManageAccountsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Manage User" />
            </ListItemButton>
               <ListItemButton
              sx={{ pl: 4 }}
              selected={isActive("/warals/manage-client")}
onClick={() => navigate("/warals/manage-client")}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <ManageAccountsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Manage Client" />
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </Box>
  );
}

export default Sidebar;
